import { SimpleGrid, Checkbox, Text } from '@chakra-ui/react';
import { useCompanyForm } from '../../hooks/useCompanyForm';
import { getBillingFieldPaths, getBillingSettings } from '../../constants';

const invoiceExportToggles = [
    {
        key: 'billShowCDR',
        label: 'CDR Details',
        hideForModes: ['Wholesaler', 'Partner'],
    },
    {
        key: 'billShowRGS',
        label: 'RGS Details',
    },
    {
        key: 'billShowCompany',
        label: 'Company Details',
    },
    {
        key: 'billShowUsers',
        label: 'User Details',
    },
    {
        key: 'billShowTrunk',
        label: 'Trunk Details',
    },
    {
        key: 'billShowNumberBlock',
        label: 'Number Block Details',
    },
    {
        key: 'billShowZero',
        label: '$0 Items',
    },
];

const InvoiceExportToggles = ({ organisationMode }) => {
    const { formData, updateFormData } = useCompanyForm();
    const billingFieldPaths = getBillingFieldPaths(organisationMode);
    const billingSettings = getBillingSettings(formData, organisationMode);

    return (
        <SimpleGrid columns={4} spacingY={2} spacingX={8} width="100%" py={2}>
            {invoiceExportToggles
                .filter(
                    (toggle) =>
                        !toggle.hideForModes?.includes(organisationMode),
                )
                .map((toggle) => (
                    <Checkbox
                        key={toggle.key}
                        isChecked={billingSettings?.[toggle.key] || false}
                        isDisabled={billingSettings?.billOneLine === true}
                        onChange={(e) =>
                            updateFormData(
                                `${billingFieldPaths.SETTINGS}.${toggle.key}`,
                                e.target.checked,
                            )
                        }
                        display="flex"
                        alignItems="center"
                        height="40px"
                        sx={{ verticalAlign: 'middle' }}>
                        <Text
                            fontSize="13px"
                            lineHeight="40px"
                            height="40px"
                            display="flex"
                            alignItems="center">
                            {toggle.label}
                        </Text>
                    </Checkbox>
                ))}
        </SimpleGrid>
    );
};

export default InvoiceExportToggles;
